export interface TaskRoot {
  '@odata.context': string;
  value: Task[];
}

export interface Task {
  '@odata.etag': string;
  projectNo: string;
  phaseNo: string;
  taskNo: string;
  taskName: string;
  taskNotes: string;
  taskCategory: string;
  taskPriority: string;
  taskStartDate: string;
  taskEndDate: string;
  taskPerecentComplete: number;
  taskStatus: string;
  taskAssignedTo: string;
  taskCreationUSERID: string;
  taskEstimatedHours: number;
  actualHours: number;
  workItemId?: number | null;
}

export class TasksDomain {
  newTasks: Task[];

  constructor(newTasks?: Task[]) {
    this.newTasks = newTasks ?? [];
  }

  toJsonList(currentTasks: Record<string, Task>): Record<string, Task> {
    this.newTasks.forEach((task) => {
      if (task.taskNo) {
        currentTasks[task.taskNo] = task;
      }
    });

    return currentTasks;
  }

  toList(currentTasks: Record<string, Task>): Task[] {
    return Object.values(currentTasks);
  }
}
